export default __webpack_public_path__ + "static/media/Bar - Cards.9a9a3a32.png";